// SEO title 組字用的靜態表（TI-15592）。純常數且不依賴 props / composable，
// 放模組級避免每個 layout／GameList 實例（以及每個 SSR 請求）各配置一份巢狀陣列

// SEO 比對鍵白名單：只有這幾條路由會把路徑正規化後再查 configs/seo，
// 其餘頁面維持 seo[route.path] 直查的現行行為，避免牽動其他頁面的 title／description
export const SEO_NORMALIZED_PATHS = ['/register', '/login', '/guest', '/guest/login', '/guest/register']

// 無 client-env 條目時的頁面名稱組字來源，值為 [i18n key, 英文字面 fallback]；
// 子路由以【|】分隔頁面層級（例：Guest | Login - 站名）
export const SEO_PATH_LABELS = {
  '/register': [['common.register', 'Register']],
  '/login': [['common.login', 'Login']],
  '/guest': [['common.guest', 'Guest']],
  '/guest/login': [
    ['common.guest', 'Guest'],
    ['common.login', 'Login'],
  ],
  '/guest/register': [
    ['common.guest', 'Guest'],
    ['common.register', 'Register'],
  ],
}

// /guest 大廳的開窗子路由：畫面沿用父層 /guest，但 title 必須由 layout 依 SEO 規則輸出。
// 子元件的 useHead 後註冊、優先權高於 layout，故 GameList 在這兩條路由不設 title
export const AUTH_PANEL_SUB_ROUTES = ['/guest/login', '/guest/register']
